const inputCls = "w-full rounded-xl border border-[#EBE4DA] bg-white px-4 py-3 text-base text-[#2D2824] focus:outline-none focus:ring-2 focus:ring-[#36858B]/40";
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const isoDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const Field = ({ id, label, hint, children }) => (
  <div>
    <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-[#2D2824]">{label}</label>
    {children}
    {hint && <p className="mt-1 text-xs text-[#8A7F76]">{hint}</p>}
  </div>
);

export const GiftForm = ({ value, onChange }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const today = new Date();
  const max = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
  const badEmail = value.recipient_email && !EMAIL_RE.test(value.recipient_email.trim());
  return (
    <div className="space-y-4 rounded-2xl bg-white p-5 ring-1 ring-[#EBE4DA]">
      <Field id="gift-recipient" label="Who is this gift for?">
        <input id="gift-recipient" data-testid="gift-recipient" maxLength={60} value={value.recipient_name} onChange={set("recipient_name")} placeholder="e.g. Grandma Rosa" className={inputCls} />
      </Field>
      <Field id="gift-recipient-email" label="Their email address" hint={badEmail ? null : "We'll send them a private Claim Your Gift link. They create their own account and password."}>
        <input id="gift-recipient-email" data-testid="gift-recipient-email" type="email" inputMode="email" autoComplete="off" maxLength={120}
          value={value.recipient_email} onChange={set("recipient_email")} placeholder="name@example.com" className={inputCls} />
        {badEmail && <p data-testid="gift-email-error" className="mt-1 text-xs text-[#A84A32]">Please check the email address.</p>}
      </Field>
      <Field id="gift-from" label="From">
        <input id="gift-from" data-testid="gift-from" maxLength={60} value={value.from_name} onChange={set("from_name")} placeholder="Your name" className={inputCls} />
      </Field>
      <Field id="gift-message" label="A personal message (optional)">
        <textarea id="gift-message" data-testid="gift-message" maxLength={300} rows={3} value={value.message} onChange={set("message")}
          placeholder="Your stories matter to us. We can't wait to read them." className={inputCls} />
        <p className="mt-1 text-right text-xs text-[#8A7F76]">{value.message.length}/300</p>
      </Field>
      <Field id="gift-deliver-on" label="Delivery date (optional)" hint={value.deliver_on ? "Their email arrives at 8am Sydney time on this day." : "Leave empty to send it straight after payment."}>
        <div className="flex gap-2">
          <input id="gift-deliver-on" data-testid="gift-deliver-on" type="date" min={isoDay(today)} max={isoDay(max)}
            value={value.deliver_on} onChange={set("deliver_on")} className={inputCls} />
          {value.deliver_on && (
            <button type="button" data-testid="gift-deliver-clear" onClick={() => onChange({ ...value, deliver_on: "" })}
              className="shrink-0 rounded-xl px-3 text-sm text-[#36858B] hover:bg-[#EBF4F5]">Send now</button>
          )}
        </div>
      </Field>
    </div>
  );
};

export const GiftPreview = ({ value, occasion }) => (
  <div data-testid="gift-preview" className="self-start rounded-2xl border-2 border-[#D9A036] bg-[#FAF6F0] p-2 shadow-sm">
    <div className="rounded-xl border border-[#E06D53]/50 px-5 py-8 text-center sm:px-8">
      <img src="/brand/yljm-emblem.png" alt="" className="mx-auto h-12 w-12" />
      <p className="mt-3 text-[10px] font-bold uppercase tracking-[0.25em] text-[#36858B]">Gift certificate</p>
      {occasion && <p data-testid="gift-preview-occasion" className="mt-1 text-xs font-semibold text-[#C58F28]">{occasion}</p>}
      <p className="mt-3 font-serif text-2xl italic text-[#2D2824] sm:text-3xl">A gift of Lifetime Access</p>
      <p className="mt-3 text-sm text-[#6E665E]">lovingly given to</p>
      <p className="mt-1 break-words font-serif text-3xl font-semibold italic text-[#E06D53]">{value.recipient_name || "Their name"}</p>
      {value.message && <p className="mx-auto mt-4 max-w-sm break-words font-serif text-lg italic leading-snug text-[#2D2824]">“{value.message}”</p>}
      <p className="mt-4 text-sm text-[#6E665E]">A gift from {value.from_name || "you"}</p>
      <p className="mx-auto mt-6 inline-block rounded-lg border border-[#D9A036] bg-white px-5 py-2 font-mono text-lg tracking-wider text-[#2D2824]">GIFT-XXXX-XXXX</p>
      <p className="mt-3 text-xs text-[#8A7F76]">Your real code appears after payment</p>
    </div>
  </div>
);
